import type { LaborCostChartData } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartData.ts";
import { useTranslation } from "react-i18next";
import type { LaborCostChartSlice } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartSlice.ts";
import { formatNumber } from "@/shared/utils/Numbers.tsx";

interface UseLaborCostChartConstroller {
  slices: LaborCostChartSlice[];
  formatArcLabel: (label: string | undefined, value: number) => string;
  formatPct: (pct: number) => string;
}

export function useLaborCostChart(
  data: LaborCostChartData,
): UseLaborCostChartConstroller {
  const { t } = useTranslation("common");
  const slices = data.slices.filter((s) => s.value > 0);

  function formatArcLabel(label: string | undefined, percent: number): string {
    if (label === undefined) return "";

    let maxLength: number;

    if (percent < 5) {
      maxLength = 0;
    } else if (percent < 10) {
      maxLength = 3;
    } else if (percent < 18) {
      maxLength = 7;
    } else {
      maxLength = 10;
    }

    if (maxLength === 0) return "";

    return label.length > maxLength ?
        `${label.substring(0, maxLength)}...`
      : label;
  }

  function formatPct(percent: number): string {
    return formatNumber(t, percent, 2) + "%";
  }

  return {
    slices,
    formatArcLabel,
    formatPct,
  };
}
